<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar
                show_search
                show_month
                show_building
                :loading="loader"
                :search.sync="search"
                :chosen_month.sync="chosen_month"
                :chosen_building.sync="chosen_building"
            >
                <v-flex xs12 md2>
                    <v-select
                        label="Loại"
                        :disabled="loader"
                        v-model="chosen_type"
                        :items="list_type"
                        prepend-icon="assignment"
                        required
                        hide-details
                    ></v-select>
                </v-flex>
                <v-flex xs12 md2>
                    <v-select
                        label="% chênh lệch"
                        :disabled="loader"
                        v-model="diff_percentage"
                        :items="diff_percentage_options"
                        prepend-icon="assignment"
                        required
                        hide-details
                    ></v-select>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            :loading="loader"
                            disable-initial-sort
                            :headers="headers"
                            :search="search"
                            :items="filtered_items"
                            item-key="id"
							:pagination.sync="pagination"
                            :rows-per-page-items="rowPerPage"
                        >
                            <template #headers="props">
                                <tr>
                                    <th colspan="6">THÔNG TIN PHÒNG</th>
                                    <th
                                        colspan="5"
                                        style="text-transform: uppercase;"
                                    >SỐ {{ type_text}} THÁNG {{ chosen_month_locale }}</th>
                                </tr>
                                <tr>
                                    <th
										:class="[
											'column sortable', pagination.descending ? 'desc' : 'asc',
											header.value === pagination.sortBy ? 'active' : '',
											header.align ? `text-xs-${header.align}` : ''
										]"
										@click="changeSort(header.value)"
                                        v-for="header in props.headers"
                                        :key="header.text"
                                    >
                                        <v-icon small>arrow_upward</v-icon>
										<span style="padding-right: 16px">{{ header.text }}</span>
                                    </th>
                                </tr>
                            </template>
                            <template #items="props">
                                <tr>
                                    <td class="text-no-wrap">{{ props.item.index + 1 }}</td>
                                    <td class="text-no-wrap">{{ props.item.room_id }}</td>
                                    <td class="text-center text-no-wrap">
                                        <span
                                            :class="['v-badge', 'primary']"
                                        >{{ props.item.status_text }}</span>
                                    </td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.customer_count }}</td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.washing_machine ? "Có" : "Không" }}</td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.air_conditioner ? "Có" : "Không" }}</td>
                                    <td class="text-center text-no-wrap" style="width: 117px">{{ props.item.start_count }}</td>
                                    <td class="text-center text-no-wrap" style="width: 117px">{{ props.item.end_count }}</td>
                                    <td class="text-center text-no-wrap" style="width: 117px">{{props.item.diff}}</td>
                                    <td class="text-center text-no-wrap" style="width: 117px">{{ props.item.monthly_usage_average | formatNumber }}</td>
                                    <td class="text-left text-no-wrap" style="width: 200px">{{ props.item.note }}</td>
                                </tr>
                            </template>
                            <template #no-data>Chưa có thông tin</template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import moment from "moment";
import api from "../../api";
import { buildParamQuery, formatTimeServer, deepCopy } from "../../helpers/helpers";
import { handleData } from './handleDienNuoc'

export default {
    name: "kiem-soat-dien-nuoc",
    data() {
        return {
            search: "",
            loader: false,
            list_type: [
                { text: "Số điện", value: "E" },
                { text: "Số nước", value: "W" }
            ],
            chosen_type: "E",
            chosen_month: moment()
                .toISOString()
                .substr(0, 7),
            rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
            headers: [
                { text: "STT", align: "left", sortable: true, value: "index" },
                {
                    text: "Số Phòng",
                    align: "left",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Trạng thái",
                    align: "center",
                    sortable: true,
                    value: "diff_percentage"
                },
                {
                    text: "Người Ở",
                    align: "center",
                    sortable: true,
                    value: "customer_count"
                },
                {
                    text: "Máy Giặt",
                    align: "center",
                    sortable: true,
                    value: "is_washing_machine"
                },
                {
                    text: "Máy Lạnh",
                    align: "center",
                    sortable: true,
                    value: "is_air_conditioner"
                },
                {
                    text: "Đầu Kì",
                    align: "center",
                    sortable: true,
                    value: "start_count"
                },
                {
                    text: "Cuối Kì",
                    align: "center",
                    sortable: true,
                    value: "end_count"
                },
                {
                    text: "Tiêu Thụ",
                    align: "right",
                    sortable: true,
                    value: "diff"
                },
                {
                    text: "Trung Bình",
                    align: "right",
                    sortable: true,
                    value: "monthly_usage_average"
                },
                {
                    text: "Ghi Chú",
                    align: "center",
                    sortable: true,
                    value: "note"
                }
            ],
            items: [],
            diff_percentage_options: [
                { text: "30%", value: 0.3 },
                { text: "40%", value: 0.4 },
                { text: "50%", value: 0.5 }
            ],
            chosen_building: "BN",
            diff_percentage: 0.3,
    		pagination: {}
        };
    },
    computed: {
        chosen_month_locale() {
            return formatTimeServer(this.chosen_month + "-01").substring(5);
        },
        rooms() {
            return this.$store.state.app.rooms;
        },
        type_text() {
            return this.chosen_type === "E" ? "điện" : "nước";
        },
        filtered_items(){
            let index = 0;
            return this.items.filter(room => {
                if (!room.is_valid_contract){
                    return false
                }
                room.index = index;
                index ++
                const usage_margin = Math.ceil(room.monthly_usage_average * this.diff_percentage);

                const diff_percentage = (room.diff - room.monthly_usage_average)/room.monthly_usage_average
                room.diff_percentage = diff_percentage;

                if (!room.end_count){
                    room.status_text = `Chưa nhập cuối kì`
                    room.diff_percentage = -99;
                    return true;
                }
                if (room.end_count < room.start_count){
                    room.status_text = `Cuối kì nhỏ hơn đầu kì`
                    return true;
                }
                if (Math.abs(room.diff - room.monthly_usage_average) > usage_margin){
                    room.status_text = `${diff_percentage > 0 ? "Tăng" : "Giảm"} ${Math.round(diff_percentage*100*100)/100}%`
                    return true;
                }
                index --;
                return false;
            });
        }
    },
    watch: {
		chosen_month: {
			handler: function (nv){
				this.getData()
			},
			immediate: true
        },
        chosen_building(){
            this.getData();
        },
        chosen_type(){
            this.getData();
        }
    },
    methods: {
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
        async getData(){
            this.items = []
            const params = {
                dateMonth: this.chosen_month + '-01',
                type: this.chosen_type,
                building: this.chosen_building
            }
            const query = buildParamQuery(params)
            this.loader  = true;
            const data = await api.getBillForAudit(query)
            this.loader  = false;
            this.items = deepCopy(this.rooms.filter(room => !this.chosen_building || room.building === this.chosen_building));
            this.items = this.items.map(room => handleData(room, data.data, this.chosen_month));

        },

    }
};
</script>

<style>
</style>